const Data = {
  emotions: [
    {value:null, label: ""},
    { value: "Happiness", label: "Happiness" },
    { value: "Sadness", label: "Sadness" },
    { value: "Fear", label: "Fear" },
    { value: "Anger", label: "Anger" },
    { value: "Surprise", label: "Surprise" }
  ],
  communications: [
    {value:null, label: ""},
    { value: "Visual", label: "Visual" },
    { value: "Oral", label: "Oral" },
    { value: "Auditory", label: "Auditory" }
  ],
  challenges : [
    {value: null , label: ""},
    { label: "Difficulty recognizing facial expressions", value: "Recognizing_facial_expressions" },
    { label: "Sensory sensitivities", value: "Sensory_sensitivities" },
    { label: "Challenges in social interaction", value: "Social_interaction" },
    { label: "Communication difficulties", value: "Communication" },
    { label: "Rigid or repetitive behaviors", value: "Rigid_repetitive_behaviors" },
    { label: "Difficulty with transitions", value: "Difficulty_transitions" },
    { label: "Restricted interests", value: "Restricted_interests" },
    { label: "Challenges in executive function", value: "Executive_function" },
    { label: "Hyperactivity or impulsivity", value: "Hyperactivity_impulsivity" },
    { label: "Difficulty understanding and expressing emotions", value: "Understanding_expressing_emotions" }
  ],

  familyBond: [
    {value: null, label: ""},
    {value: 2, label: "Mother"},
    {value: 1, label:"Father"},
    {value: 4, label: "Grandfather"},
    {value: 3, label:"Grandmother"},
    {value: 5, label: "Legal guardian"}
  ],

  gender: [
    {value:null, label: ""},
    {value: 2, label: "Female"},
    {value: 1, label: "Male"}
  ],

  typeOfComunications : [
    {value:null, label: ""},
    {value:"Verbal", label: "Verbal"},
    {value:"Non-Verbal", label: "Non-Verbal"},
  ],

  optionsTea : [
    {value:null, label: ""},
    {value:"Y", label: "Yes"},
    {value:"N", label: "No"},
    {value:"Unknown", label: "Unknown diagnosis"},
  ]

}

export default Data;
